import mixpanel from 'mixpanel-browser'
import { trackEventApi } from '../api'
import { getSessionStorage, setSessionStorage } from '../helpers/localStorage';
import { v4 as uuidv4 } from 'uuid';

export const useMixPanel = () => {
// mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN, {
//     autocapture: {
//         pageview: "full-url"
//     }
// })

const mixPanelEvent = (name, data = {}) => {
    
    // try {
    //     mixpanel.track(name, { URL: window.location.href, ...data })
    // } catch (err) {
    //     console.log(err)
    // }
}

const mixPanelServerEvent = (name, data = {}) => {
  const payloadData = {
    eventName: name,
    data: {
      ...(name !== '$mp_web_page_view' && { URL: window.location.href }),
      ...data,
    }
  }
  const jsonStr = JSON.stringify(payloadData);
  const base64Encoded = btoa(unescape(encodeURIComponent(jsonStr)));
  trackEventApi({ payload: base64Encoded })
}

const getSessionId = () => {
  let sessionId = getSessionStorage('session_id');
  if (!sessionId) {
    sessionId = uuidv4();
    setSessionStorage('session_id', sessionId);
  }
  return sessionId;
}


return {
    mixPanelEvent,
    mixPanelServerEvent,
    getSessionId
}
}
